<div class="title">
    <mat-card-title *ngIf="data.isCalculating">Calculate Property Records</mat-card-title>
    <mat-card-title *ngIf="data.isReCalculating">Recalculate Property Records</mat-card-title>
</div>

<form [formGroup]="layerForm">
    <div>
        <div class="wrapperSync">
            <div class="wrapperInfo">
                <h4 class="form-cell">Data source(s) to calculate:</h4>
                <mat-icon class="description"
                    matTooltip="Default data source is indicated with an *. The default cannot be unselected.">info_outline</mat-icon>
            </div>
            <div class="wrapperInfo">
                <app-update-zc-status-button [zoningCode]="data?.zoningCode" [needWindowReload]="false"
                    (updatedZoningCode)="setCachedZoningCode($event)" [updateZCRecord]="false" [getDefaultDSC]="true"
                    [stateEnv]="data.stateEnv"></app-update-zc-status-button>
                <mat-icon
                    matTooltip=" Update Cached Zoning Code if data source count equal to N/A">info_outline</mat-icon>
            </div>
        </div>

        <mat-checkbox formControlName="city" [disableRipple]="isCityDefault"
            (click)="isCityDefault?$event.preventDefault():null">City{{isCityDefault?'*':''}}
            ({{isLayerCached(cachedPRCityCount) ?
            cachedPRCityCount :
            'N/A'}})</mat-checkbox>
        <mat-checkbox formControlName="county" [disableRipple]="isCountyDefault"
            (click)="isCountyDefault?$event.preventDefault():null">County{{isCountyDefault?'*':''}}
            ({{isLayerCached(cachedPRCountyCount) ?
            cachedPRCountyCount :
            'N/A'}})</mat-checkbox>
        <mat-checkbox formControlName="state" [disableRipple]="isStateDefault"
            (click)="isStateDefault?$event.preventDefault():null">State{{isStateDefault?'*':''}}
            ({{isLayerCached(cachedPRStateCount) ?
            cachedPRStateCount :
            'N/A'}})</mat-checkbox>
    </div>

    <div>
        <div class="wrapperInfo">
            <h4>Property record bunch size:</h4>
            <mat-icon
                matTooltip="Defines how many records the system will request from the database at a time.">info_outline</mat-icon>
        </div>
        <app-labeled-slider style="width: calc( 100% - 20px )"
            [value]="schedulerSettings?.defaultMaxPRsBunchSize || processSettings.maxPRsBunchSize"
            [maxValue]="schedulerSettings?.maxPRsBunchSizeAllowed || processSettings.maxPRsBunchSize"
            (valueChanged)="bunchChanged($event)">
        </app-labeled-slider>
    </div>

    <div>
        <div class="wrapperInfo">
            <h4>Thread count:</h4>
            <mat-icon
                matTooltip="Defines how many parallel processes will be running during calculation. Or how many lanes of traffic will be open during calculation.">info_outline</mat-icon>
        </div>
        <app-labeled-slider style="width: calc( 100% - 20px )"
            [value]="data.maxThreadsCount || processSettings.maxThreadsCount"
            [maxValue]="schedulerSettings?.maxThreadsCount || processSettings.maxThreadsCount"
            (valueChanged)="threadsCountChanged($event)">
        </app-labeled-slider>
    </div>

    <div class="checkbox">
        <mat-checkbox [checked]="processSettings.useGAPIDataCache" (change)="useGAPIDataCacheChanged($event)">Use
            in-memory
            cache of GAPI data</mat-checkbox>
    </div>

    <div class="checkbox" *ngIf="showSyncSolrAUDataCheckbox">
        <mat-checkbox [checked]="processSettings.syncSolrData" (change)="syncSolrDataChanged($event)">Sync Solr AU
            Data</mat-checkbox>
    </div>


    <div class="dialog-footer">
        <div class="action-button">
        </div>
        <mat-dialog-actions>
            <button class="action-button" mat-raised-button color="primary" [mat-dialog-close]="processSettings"
                [disabled]="isDisabled">{{
                data.isCalculating ? 'Calculate' : 'Recalculate'}}</button>
            <button class="action-button" mat-raised-button color="secondary" [mat-dialog-close]="false">Cancel</button>
        </mat-dialog-actions>
    </div>
</form>